import React, { useState } from "react";
import axios from "axios";

const inputClass =
  "block w-full rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-gray-900 focus:border-tangerine focus:ring-tangerine placeholder-gray-400 text-base outline-none transition";

const labelClass = "textSpaceMonoWhite block mb-1 font-agrandir text-gray-900";

const RegisterEvent = () => {
  const [form, setForm] = useState({
    nom: "",
    prenoms: "",
    tel: "",
    email: "",
    profession: "",
    secteur: "",
    membrePMI: "",
    pmiId: "",
    commentaires: "",
    eventDescription: "Conférence Annuelle PMI Togo 2025",
  });

  const [step, setStep] = useState(1);
  const [paymentData, setPaymentData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Inscription
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/payment/create_order`,
        form,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.status === "Done") {
        setPaymentData(response.data);
        setStep(3);
      } else {
        setPaymentData(response.data);
        setStep(2);
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du formulaire :", error);
      alert(
        "Une erreur est survenue lors de l'inscription. Veuillez réessayer."
      );
    }
  };

  // Payement SEMOA
  const handleSemoaPayment = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/payment/confirm`,
        { orderReference: paymentData?.order_reference },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.state === "Paid") {
        setStep(3);
      } else {
        alert("Le paiement n'a pas encore été confirmé.");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du formulaire :", error);
      alert(
        "Une erreur est survenue lors de l'inscription. Veuillez réessayer."
      );
    }
  };

  return (
    <div className="flex flex-col items-center w-full py-10 mt-20">
      <div className="w-full max-w-xl">
        {step === 1 && (
          <form
            onSubmit={handleSubmit}
            className="bg-white shadow-lg rounded-lg p-8 w-full flex flex-col gap-6 mt-20 textSpaceMonoWhite"
          >
            <img
              src="/conference_annuelle_2025.jpg"
              alt="Programme Conférence PMI Togo 2025"
              className="w-full h-auto rounded-lg mb-4"
            />
            {/* <h2 className="textSpaceMonoWhite text-2xl text-violet text-center">
              Conférence Annuelle PMI Togo 2025
            </h2> */}
            <h2 className="textSpaceMonoWhite text-md text-violet mb-2 text-center">
              <span className="text-tangerine">*</span> Veuillez remplir le
              formulaire pour vous inscrire
            </h2>
            <div>
              <label className={labelClass} htmlFor="nom">
                Nom <span className="text-red-700">*</span>
              </label>
              <input
                id="nom"
                name="nom"
                value={form.nom}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="Votre nom"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="prenoms">
                Prénom <span className="text-red-700">*</span>
              </label>
              <input
                id="prenoms"
                name="prenoms"
                value={form.prenoms}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="Votre prénom"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="tel">
                Téléphone <span className="text-red-700">*</span>
              </label>
              <input
                id="tel"
                name="tel"
                value={form.tel}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="Ex: +228XXXXXXXX"
                pattern="\+228[0-9]{8}"
                title="Le numéro doit être au format +228XXXXXXXX"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="email">
                Email <span className="text-red-700">*</span>
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="name@company.com"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="profession">
                Profession <span className="text-red-700">*</span>
              </label>
              <input
                id="profession"
                name="profession"
                value={form.profession}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="Votre profession"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="secteur">
                Secteur d'activités <span className="text-red-700">*</span>
              </label>
              <input
                id="secteur"
                name="secteur"
                value={form.secteur}
                onChange={handleChange}
                required
                className={inputClass}
                placeholder="Votre secteur d'activités"
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="membrePMI">
                Êtes-vous membre de PMI ?{" "}
                <span className="text-red-700">*</span>
              </label>
              <select
                id="membrePMI"
                name="membrePMI"
                value={form.membrePMI}
                onChange={handleChange}
                required
                className={inputClass}
              >
                <option value="">Sélectionnez</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>
            </div>
            <div>
              <label className={labelClass} htmlFor="pmiId">
                PMI ID{" "}
                {form.membrePMI === "oui" && (
                  <span className="text-red-700">*</span>
                )}
              </label>
              <input
                id="pmiId"
                name="pmiId"
                value={form.pmiId}
                onChange={handleChange}
                className={inputClass}
                placeholder="Votre PMI ID"
                required={form.membrePMI === "oui"}
                disabled={form.membrePMI !== "oui"}
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="commentaires">
                Commentaires
              </label>
              <textarea
                id="commentaires"
                name="commentaires"
                value={form.commentaires}
                onChange={handleChange}
                className={inputClass + " min-h-[100px]"}
                placeholder="Vos commentaires"
              />
            </div>
            <button
              type="submit"
              className="textSpaceMonoWhite bg-violet text-white font-agrandir rounded-lg py-3 mt-4 pb-2 hover:bg-tangerine transition text-base"
            >
              Continuer vers le paiement
            </button>
          </form>
        )}

        {step === 2 && paymentData && (
          <div className="textSpaceMonoWhite bg-white shadow-lg rounded-lg p-8 flex flex-col items-center gap-6 mt-20 w-full">
            <h2 className="text-2xl text-violet mb-2 text-center">
              Paiement de facture
            </h2>
            <p className="text-center text-sm">
              Veuillez procéder au paiement :
            </p>
            <div className="w-full flex flex-col md:flex-row gap-6 items-center justify-center">
              {/* QR Code */}
              {paymentData.qrcode_url && (
                <div className="flex flex-col items-center">
                  <img
                    src={paymentData?.qrcode_url}
                    alt="QR Code"
                    className="w-40 h-40 mb-2"
                  />
                  <a
                    href={paymentData?.bill_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-tangerine underline text-sm"
                  >
                    Payer la facture
                  </a>
                </div>
              )}
              {/* Bill details */}
              <div className="flex flex-col gap-2 text-gray-700 text-base">
                <div>
                  <span className="font-bold">Montant:</span>{" "}
                  <span className="text-red-700">
                    {paymentData?.amount} {paymentData?.currency}
                  </span>
                </div>
                <div>
                  <span className="font-bold">Référence:</span>{" "}
                  {paymentData?.order_reference}
                </div>
                <div>
                  <span className="font-bold">Nom:</span>{" "}
                  {paymentData?.client?.firstname}{" "}
                  {paymentData?.client?.lastname}
                </div>
                <div>
                  <span className="font-bold">Téléphone:</span>{" "}
                  {paymentData?.client?.phone}
                </div>
              </div>
            </div>

            {/* Option to check payment or continue */}
            <button
              onClick={handleSemoaPayment}
              className="bg-red-700 text-white font-agrandir rounded-lg py-3 px-8 hover:bg-green-700 transition text-base mt-4 pb-2"
            >
              J'ai payé, continuer
            </button>
          </div>
        )}

        {step === 3 && (
          <div className="textSpaceMonoWhite bg-white shadow-lg rounded-lg p-8 flex flex-col items-center gap-6 mt-20">
            <h2 className="text-2xl text-green-700 mb-2 text-center">
              Inscription réussie !
            </h2>
            <p className="text-gray-700 text-center">
              Merci pour votre inscription.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisterEvent;
